// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cM3bX","contentWrapper":"styles_contentWrapper__IJP1c"};